module.exports = __webpack_public_path__ + "public/files/img/3.a0f68a39.png";